export default () => ({
  showResult: false,
  showCustomFormat: false,
  cover: false,
  weight: null,
  coverWeight: null,
  cardboardBackWeight: 350,
  cassette: null,
  width: null,
  height: null,
  amount: 0,
  sheets: 0,
  result: 0,
  pieceG: '',
  pieceKg: '',
  totalG: '',
  totalKg: '',
  errors: [],

  reset() {
    this.showResult = false
    this.showCustomFormat = false
    this.cover = false
    this.weight = 0
    this.coverWeight = 0
    this.cassette = 0
    this.width = 0
    this.height = 0
    this.amount = 0
    this.sheets = 0
    this.result = 0
    this.pieceG = ''
    this.pieceKg = ''
    this.totalG = ''
    this.totalKg = ''
    this.erros = []
    let forms = document.querySelectorAll('form')
    forms.forEach((form) => form.reset())
  },

  convertToKg(result, amount) {
    return (result * amount) / 1000
  },

  // Set width and height based on selected format
  setWidthAndHeight() {
    this.width = parseFloat(
      this.$el.querySelector('option:checked').dataset.width,
    )
    this.height = parseFloat(
      this.$el.querySelector('option:checked').dataset.height,
    )
  },

  calcPlano() {
    this.errors = []
    this.checkMaterial(this.weight)
    this.checkWidthAndHeight(this.width, this.height)
    this.checkAmount(this.amount)
    if (this.errors.length > 0) return

    this.result = ((this.width * this.height) / 1000) * (this.weight / 1000)
    this.pieceG = Math.round(this.result)
    this.pieceKg = this.convertToKg(this.result, 1).toFixed(3)
    this.totalG = Math.round(this.result * this.amount)
    this.totalKg = this.convertToKg(this.result, this.amount).toFixed(2)
    this.showResult = true
  },

  calcBrochures() {
    this.errors = []
    if (this.cover) {
      this.resultCover =
        ((this.width * this.height) / 1000) * (this.coverWeight / 1000) * 2
      this.checkCoverWeight(this.coverWeight)
    } else {
      this.resultCover = 0
    }
    this.checkWidthAndHeight(this.width, this.height)
    this.checkMaterial(this.weight)
    this.checkSheets(this.sheets)
    this.checkAmount(this.amount)

    if (this.errors.length > 0) return

    this.result = ((this.width * this.height) / 1000) * (this.weight / 1000)
    this.result = (this.result * this.sheets) / 2
    this.pieceG = Math.round(this.result + this.resultCover)
    this.pieceKg = this.convertToKg(this.result + this.resultCover, 1).toFixed(
      3,
    )
    this.totalG = Math.round(this.result + this.resultCover) * this.amount
    this.totalKg = this.convertToKg(
      this.result + this.resultCover,
      this.amount,
    ).toFixed(2)

    this.showResult = true
  },

  calcPads() {
    this.errors = []
    this.checkMaterial(this.weight)
    this.checkWidthAndHeight(this.width, this.height)
    this.checkSheetsPerBloc(this.sheets)
    this.checkAmount(this.amount)
    if (this.errors.length > 0) return

    this.result = ((this.width * this.height) / 1000) * (this.weight / 1000)
    this.result = this.result * this.sheets
    this.cardboardBack =
      ((this.width * this.height) / 1000) * (this.cardboardBackWeight / 1000)
    this.pieceG = Math.round(this.result + this.cardboardBack)
    this.pieceKg = this.convertToKg(
      this.result + this.cardboardBack,
      1,
    ).toFixed(3)
    this.totalG = Math.round(this.result + this.cardboardBack) * this.amount
    this.totalKg = this.convertToKg(
      this.result + this.cardboardBack,
      this.amount,
    ).toFixed(2)

    this.showResult = true
  },

  calcRollups() {
    this.errors = []
    this.checkWidthAndHeight(this.width, this.height)
    this.checkMaterial(this.weight)
    this.checkAmount(this.amount)
    if (this.errors.length > 0) return

    this.result =
      ((this.width * this.height) / 1000) * (this.weight / 1000) + this.cassette
    this.pieceG = Math.round(this.result)
    this.pieceKg = this.convertToKg(this.result, 1).toFixed(3)
    this.totalG = Math.round(this.result) * this.amount
    this.totalKg = this.convertToKg(this.result, this.amount).toFixed(2)
    this.showResult = true
  },

  checkMaterial(weight) {
    try {
      if (weight < 1) {
        throw new Error('Kies een drager.')
      }
    } catch ({ name, message }) {
      this.errors.push(message)
    }
  },

  checkWidthAndHeight(width, height) {
    try {
      if (width < 1 || height < 1) {
        throw new Error('Geef een geldig formaat in.')
      }
    } catch ({ name, message }) {
      this.errors.push(message)
    }
  },

  checkSheetsPerBloc(sheets) {
    try {
      if (sheets < 1) {
        throw new Error('Selecteer aantal vellen.')
      }
    } catch ({ name, message }) {
      this.errors.push(message)
    }
  },

  checkSheets(sheets) {
    try {
      if (sheets < 8 || sheets > 636) {
        throw new Error("Binnenwerk is minimum 8 en maximum 636 pagina's.")
      }
    } catch ({ name, message }) {
      this.errors.push(message)
    }
  },

  checkCoverWeight(cover) {
    try {
      if (cover < 1) {
        throw new Error('Kies een geldige cover.')
      }
    } catch ({ name, message }) {
      this.errors.push(message)
    }
  },

  checkAmount(amount) {
    try {
      if (amount < 1) {
        throw new Error('Oplage moet groter zijn dan 0.')
      }
    } catch ({ name, message }) {
      this.errors.push(message)
    }
  },
})
